import { render, staticRenderFns } from "./AcademyQA.vue?vue&type=template&id=1e4f08ae"
import script from "./AcademyQA.vue?vue&type=script&lang=ts"
export * from "./AcademyQA.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports